<template>
  <div
    :style="myStyle()"
  >
    <!-- $attrs传递属性 -->
    <ag-grid-vue
      ref="grid"
      v-bind="$attrs"
      style="height: calc(100% - 50px);"
      class="ag-theme-alpine"
      :grid-options="gridOptions"
      :pagination="true"
      :pagination-auto-page-size="false"
      :pagination-page-size="paginationPageSize"
      v-on="$listeners"
      @first-data-rendered="onFirstDataRendered"
      @filterChanged="onFilterChanged"
    >
      <!-- $slots传递插槽 -->
      <!-- <template
        v-for="(_slotValue, name) in $slots"
        #[name]="scopedData"
      >
        <slot
          :name="name"
          v-bind="scopedData"
        />
      </template> -->
    </ag-grid-vue>
    <div
      class="d-flex align-center"
      :style="`height: 50px;`"
    >
      <div class="mr-2">
        每页行数:
      </div>
      <div>
        <v-select
          v-model="paginationPageSize"
          outlined
          dense
          :items="paginationPageSizeOptions"
          small
          hide-details
          class="ag-select align-self-center"
          style="max-width: min-content;"
          @change="onPageSizeChanged"
        />
      </div>
      <v-spacer />
      <div class="mt-2 d-flex">
        <v-pagination
          v-model="curPage"
          :length="totalPages"
          :total-visible="7"
          color="primary"
          @input="onPaginationInput"
        />
        <div class="agText ag-rightWidth ml-6 d-flex align-center">
          <span class="mr-1">第</span>
          <v-text-field
            v-model="curPageText"
            style="max-width: 50px;"
            outlined
            dense
            hide-details
          />
          <span class="ml-1">页</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { LicenseManager } from 'ag-grid-enterprise';
import { AgGridVue } from "ag-grid-vue";

LicenseManager.setLicenseKey('CompanyName=Suzhou ruhlamat Smart Technologies Co., Ltd.,LicensedApplication=Infinity,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=30,AssetReference=AG-030422,SupportServicesEnd=30_August_2023_[v2]_MTY5MzM1MDAwMDAwMA==28423dd515d527503fc5a257dc86a8ac');

export default {
  name: "VritualGrid",
  components: {
    AgGridVue,
  },

  props: {
    styles: {
      type: String,
      // 默认给一个高度，防止没有显示
      default: () => ('height: 300px; width: 100%;'),
    },
  },

  data() {
    return {
      gridOptions: { // 表格配置
        defaultColDef: {
          sortable: true,
          filter: true,
          resizable: true,
          floatingFilter: true,
          minWidth: 200,
          flex: 1,
        },
        suppressPaginationPanel: true, // 隐藏默认页脚分页
      },
      paginationPageSize: 5, // 每页n个
      paginationPageSizeOptions: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '50', value: 50 },
        { text: '100', value: 100 },
        { text: '500', value: 500 },
        { text: '1000', value: 1000 },
        { text: 'All', value: 0 },
      ],
      totalRecords: 0, // 总条数
      curPage: 1, // 当前页码
      totalPages: 0, // 总页码
    };
  },

  computed: {
    curPageText: {
      get() {
        return this.curPage;
      },
      set(val) {
        if (!Number(val)) {
          this.gridApi.paginationGoToPage(0);
          this.curPage = 1;
        } else if (Number(val) > this.totalPages) {
          this.gridApi.paginationGoToPage(this.totalPages - 1);
          this.curPage = this.totalPages;
        } else {
          this.gridApi.paginationGoToPage(Number(val) - 1);
          this.curPage = Number(val);
        }
      },
    },
    rowData() {
      return this.$attrs['row-data'] || this.$attrs.rowData;
    },
  },

  watch: {
    rowData: {
      handler(val) {
        if (val) {
          this.initPagination(val);
        }
      },
      // immediate: true, // 默认已经初始化这里不需要
      deep: true,
    }
  },
  mounted() {
    // console.log(this.$attrs, 'attrs 除了props以外的参数');
    // console.log(this.$slots, 'slots 插槽');
    // console.log(this.$refs.grid, '子组件 grid refs');
    // console.log(this.$listeners, '接收到的事件');

    // #region 把表格的ref暴露给container 建议少用ref以避免打破单向数据流
    // TODO vue 不支持 ref传参
    // const grid = this.$refs.grid;
    // for (const key in grid) {
    //   this[key] = grid[key]; // ?
    // }
    // #endregion
  },

  methods: {
    myStyle() {
      // 有传入样式 就用传入的
      // 对于 style 优先于 styles style部分属性可以覆盖styles对应属性
      if (this.styles) {
        return this.styles
      }
    },
    // 初始化api
    onFirstDataRendered(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      const rowData = params.api.getModel().rowsToDisplay;
      this.initPagination(rowData);
    },
    // 筛选条件修改方法
    onFilterChanged() {
      // 重新计算分页
      const tableRows = this.gridApi.getModel().rowsToDisplay;
      this.initPagination(tableRows);
      // 页码超出重置当前页码
      if (this.totalPages < this.curPage) {
        console.log(this.curPage, this.totalPages, 'go to last');
        this.curPage = this.totalPages;
        this.onPaginationInput(this.curPage);
      }
    },
    onPageSizeChanged() {
      // 重新计算分页
      const tableRows = this.gridApi.getModel().rowsToDisplay;
      this.initPagination(tableRows);
      // 页码超出重置当前页码
      if (this.totalPages < this.curPage) {
        console.log(this.curPage, this.totalPages, 'go to last');
        this.curPage = this.totalPages;
        this.onPaginationInput(this.curPage);
      }
    },
    // 重新加载分页总数
    initPagination(rowData) {
      this.totalRecords = rowData.length || 0;
      if (rowData.length && this.paginationPageSize) {
        this.totalPages = Math.ceil(rowData.length / this.paginationPageSize);
      } else {
        this.totalPages = 0;
      }
    },
    onPaginationInput(page) {
      // aggrid的第一页是0
      this.gridApi.paginationGoToPage(page - 1);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~ag-grid-community/styles/ag-grid.css";
@import "~ag-grid-community/styles/ag-theme-alpine.css";

</style>